import Paper from '@mui/material/Paper';
import React from 'react';

export default function StatementsPanel(props) {
    return (
        <Paper sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            overflow: 'auto',
        }}>
            {props.children}
        </Paper>
    );
}
